<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="idForm" name="nomForm">

        <div class="grid form-group">

          <div class="col-12 md:col-4 lg:col-4 md:col-offset-1 lg:col-offset-1">
            <div class="div-form">
              <label>* {{'GARANTIASIDONEAS.LBL_TIPOPRODUCTOR' | translate}}:</label>

              <p-multiSelect id="idCanal" name="nomCanal" [options]="lisDestino"
                             filter="filter"
                             defaultLabel="{{ 'LBL_SELECCIONE' | translate}}"
                             selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate}}"
                             formControlName="idTiposProductores"
                             emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                             emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                             optionValue="value"
                             optionLabel="label"
              ></p-multiSelect>

              <div class="p-message p-messages-error p-corner-all"
                   *ngIf="submitted && f.idTiposProductores.invalid">
                {{ 'GARANTIASIDONEAS.LBL_TIPOPRODUCTOR' | translate}} {{ 'LBL_REQUERIDO' | translate}}
              </div>
            </div>
          </div>


        </div>

        <div class="grid form-footer-buttons">
          <div class="form-group col-12">

            <div *ngIf="!guardando">
              <button icon="fa fa-plus" label="{{'LBL_AGREGAR' | translate }}"
                      type="submit"
                      pButton></button>
            </div>

            <div *ngIf="guardando">
              <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
              <span>{{'LBL_GUARDANDO' | translate }}</span>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-table [columns]="columnas" [loading]="carTabla" #dt
               [value]="getGarantiasTiposProductores" selectionMode="single" dataKey="idGarantiaIdoneaTipoProductor"
               [paginator]="true" [rows]="10"  paginatorPosition="bottom">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort"
                class="text-center">
              {{col.header}}
              <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr [pSelectableRow]="row">
            <td class="table-break">{{row.codigoTipoProductor}}</td>
            <td class="table-break">{{row.tipoProductor}}</td>
            <td class="text-center">
              <div class="btn-group" role="group">
                <button type="button" class="p-button p-button-danger btn" icon="fa fa-trash" data-toggle="tooltip"
                        title="{{'BTN_DESHABILITAR' | translate}}" pButton
                        (click)="disable(row)" ></button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length">
              {{ 'MSG_NOHAYREGISTROS' | translate}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>

</div>
<p-confirmDialog #cd key="garantia-idoneas-tipo-productor" appendTo="body">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>

